import SimpleAccordion from './simple-accordion';
export default SimpleAccordion;
